import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useIsLoggedIn } from '../../state/hooks/ActiveUserHooks'

export const useRedirectLoggedIn = () => {
	const isLoggedIn = useIsLoggedIn()
	const location = useLocation()

	const logoutPages = ['/', '/registration/credentials', '/registration/confirmation/email', '/invite']

	if (logoutPages.includes(location.pathname) && isLoggedIn) {
		return <Navigate replace to="/main" />
	}
}
